import { useEffect } from 'react';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { MessageCode } from 'src/common/models/message';

export const useBeforeSSUnload = () => {
  const ctx = useSSContext();

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };

    if (
      !ctx.lastJsonMessage ||
      ![MessageCode.Error, MessageCode.Logout].includes(
        ctx.lastJsonMessage?.messageCode
      )
    ) {
      window.addEventListener('beforeunload', handleBeforeUnload);
    }

    if (ctx.connectionLost) {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [ctx.lastJsonMessage, ctx.connectionLost]);
};
